import { Link, useForm, Head } from '@inertiajs/react';
import React from 'react';
import useRoute from '@/Hooks/useRoute';
import ContainerAuthForm from '@/Components/Containers/ContainerAuthForm';
import Button from '@/Components/Buttons/Button';
import InputToggle from '@/Components/Inputs/InputToggle';
import Input from '@/Components/Inputs/Input';
import ValidationErrors from '../../Components/Utility/ValidationErrors';

export default function Login({ canResetPassword, status }) {
  const route = useRoute();
  const form = useForm({
    email: '',
    password: '',
    remember: '',
  });

  function onSubmit(e) {
    e.preventDefault();
    form.post(route('login'), {
      onFinish: () => form.reset('password'),
    });
  }

  return (
    <ContainerAuthForm>
      <Head title="Login" />

      <ValidationErrors />

      {status && (
        <div className="mb-4 text-sm font-medium text-green-600">{status}</div>
      )}

      <form onSubmit={onSubmit}>
        <div>
          <Input
            id="email"
            type="email"
            label="Email"
            value={form.data.email}
            onChange={e => form.setData('email', e.currentTarget.value)}
            autoFocus
            error={form.errors.email}
            required
          />
        </div>
        <div className="mt-4">
          <Input
            id="password"
            type="password"
            label="Password"
            value={form.data.password}
            onChange={e => form.setData('password', e.currentTarget.value)}
            autoComplete="current-password"
            error={form.errors.password}
            required
          />
        </div>

        <div className="mt-4">
          <label className="flex items-center">
            <InputToggle
              name="remember"
              checked={form.data.remember === 'on'}
              onChange={e =>
                form.setData('remember', e.currentTarget.checked ? 'on' : '')
              }
            />
            <span className="ml-2 text-sm text-gray-600">Remember me</span>
          </label>
        </div>
        <div className="mt-8 flex items-end justify-between sm:space-y-0">
          <div className="flex w-full flex-col flex-wrap items-center justify-end gap-4">
            <div className="w-full">
              <Button disabled={form.processing} type="submit" style="admin">
                <p className="col-span-2 w-full text-base">Login</p>
              </Button>
            </div>
            <div className="mt-4 flex w-full justify-between">
              {canResetPassword && (
                <Link href={route('password.request')}>
                  <Button style="underline">
                    <p className="text-sm">Forgot your password?</p>
                  </Button>
                </Link>
              )}
              {/*
                <Link
                  href={route('register')}
                >
                  <Button 
                    style='underline'
                  >
                    <p className='text-sm'>Sign Up?</p>
                  </Button>
                </Link>
                */}
            </div>
          </div>
        </div>
      </form>
    </ContainerAuthForm>
  );
}
